import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "src/pages/home";
import PersonalPolicy from "src/pages/personal-policy";
import AccomodationContract from "src/pages/accomodation-contract";
import Access from "src/pages/access";
import Faq from "src/pages/faq";
import Activity from "src/pages/activity";
import FacilityOverview from "src/pages/facility-overview";
import NotFound from "src/pages/not-found";
import Reservation from "src/pages/reservation";
import Complete from "src/pages/reservation/complete";
import { Header } from "src/components/header";
import { ScrollToTop } from "src/components/scroll-top";

function App() {
  return (
    <main className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/personal-policy" element={<PersonalPolicy />} />
          <Route
            path="/accomodation-contract"
            element={<AccomodationContract />}
          />
          <Route path="/faq" element={<Faq />} />
          <Route path="/access" element={<Access />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/facility-overview" element={<FacilityOverview />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/reservation/complete" element={<Complete />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </main>
  );
}

export default App;
